import React, { useState, useEffect } from 'react';
import './VersionHistory.css';
import VersionHistoryService from '../services/VersionHistoryService';

const VersionHistory = () => {
  // Use localStorage to persist user's preference for showing/hiding version history
  const [isOpen, setIsOpen] = useState(() => {
    const savedState = localStorage.getItem('versionHistoryOpen');
    return savedState ? JSON.parse(savedState) : false;
  });

  // Get version history from service
  const [versions, setVersions] = useState([]);
  const [currentVersion, setCurrentVersion] = useState('');

  useEffect(() => {
    // Get version history from service
    const versionHistory = VersionHistoryService.getVersionHistory();
    setVersions(versionHistory);
    
    // Get current version
    setCurrentVersion(VersionHistoryService.getCurrentVersion());
  }, []);
  
  // Save state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('versionHistoryOpen', JSON.stringify(isOpen));
  }, [isOpen]);

  // Handle click outside to close modal
  useEffect(() => {
    if (!isOpen) return;
    
    const handleClickOutside = (event) => {
      if (!event.target.closest('.version-history-modal') && 
          !event.target.closest('.version-history-toggle')) {
        setIsOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  // Handle Escape key to close modal
  useEffect(() => {
    if (!isOpen) return;
    
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };
    
    document.addEventListener('keydown', handleEscapeKey);
    return () => document.removeEventListener('keydown', handleEscapeKey);
  }, [isOpen]);

  return (
    <div className="version-history-container">
      <button 
        className="version-history-toggle" 
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? "Hide Version History" : "Version History"}
      </button>
      
      {isOpen && (
        <div className="version-history-modal">
          <div className="version-history-header">
            <h2>Version History</h2>
            <button className="close-button" onClick={() => setIsOpen(false)}>×</button>
          </div>
          <div className="version-history-content">
            {versions.map((version, index) => (
              <div key={index} className="version-entry">
                <h3>Version {version.version} <span className="version-date">({version.date})</span></h3>
                <ul>
                  {version.changes.map((change, changeIndex) => (
                    <li key={changeIndex}>{change}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default VersionHistory;
